import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

const getSize = (
  isSharing: boolean,
  type:
    | 'nameContainerHeight'
    | 'namePaddingLeft'
    | 'namePaddingRight'
    | 'reactionContainerSize'
    | 'reactionFontSize'
    | 'offset'
    | 'userContainerSize',
) => {
  const platform = Platform.OS === 'web' ? 'web' : 'noweb';

  const source = {
    nameContainerHeight: {
      web: isSharing ? 16 : 32,
      noweb: 22,
    },
    namePaddingLeft: {web: isSharing ? 6 : 13, noweb: 10},
    namePaddingRight: {web: isSharing ? 6 : 13, noweb: 10},
    reactionContainerSize: {web: isSharing ? 16 : 32, noweb: 22},
    reactionFontSize: {web: isSharing ? 7 : 19, noweb: 13},
    offset: {web: isSharing ? 4 : 8, noweb: 6},
    userContainerSize: {web: isSharing ? 28 : 135, noweb: 92},
  };

  return source[type][platform];
};

const reactionContainerPlusOffsetSize = (
  isSharing: boolean,
  isTwoContainer: boolean,
) => {
  const leftOffset = getSize(isSharing, 'offset');
  const rightOffset = getSize(isSharing, 'offset');
  const marginSize = getSize(isSharing, 'offset');
  const reactionContainerSizePlusOffset = getSize(
    isSharing,
    'reactionContainerSize',
  );

  if (isTwoContainer) {
    return reactionContainerSizePlusOffset + leftOffset + rightOffset;
  } else {
    return (
      reactionContainerSizePlusOffset + leftOffset + rightOffset + marginSize
    );
  }
};

const sizeForContainer = (
  isReactionOnn: boolean,
  isMicroOnn: boolean,
  width: number,
  isSharing: boolean,
) => {
  if (isReactionOnn && isMicroOnn) {
    return width - reactionContainerPlusOffsetSize(isSharing, true) * 2;
  } else {
    return width - reactionContainerPlusOffsetSize(isSharing, false);
  }
};

const calculatedWithForName = (
  isReactionOnn: boolean,
  isMicroOnn: boolean,
  width: number,
  isSharing: boolean,
) => {
  if (isReactionOnn || isMicroOnn) {
    return sizeForContainer(isReactionOnn, isMicroOnn, width, isSharing);
  } else {
    return '100%';
  }
};

const withWithOffset = (width: number, isSharing: boolean) => {
  const leftOffset = getSize(isSharing, 'offset');
  const rightOffset = getSize(isSharing, 'offset');

  return width - leftOffset - rightOffset;
};

export default (
  props: ITheme,
  isSharing: boolean,
  width: number,
  isReactionOnn: boolean,
  isMicroOnn: boolean,
) => {
  return CreateResponsiveStyle(
    {
      container: {
        backgroundColor: props.colors.lightGrey,
        borderRadius: 8,
        marginRight: 15,
        marginBottom: 15,
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      },
      nameContainer: {
        maxWidth: calculatedWithForName(
          isReactionOnn,
          isMicroOnn,
          width,
          isSharing,
        ),
        height: getSize(isSharing, 'nameContainerHeight'),
        borderRadius: 6,
        backgroundColor: props.colors.osloGray,
        alignItems: 'flex-start',
        justifyContent: 'center',
      },
      name: {
        paddingLeft: getSize(isSharing, 'namePaddingLeft'),
        paddingRight: getSize(isSharing, 'namePaddingRight'),
        color: props.colors.white,
        ellipsizeMode: 'tail',
        fontSize: isSharing ? 7 : 14,
      },
      reactionContainer: {
        width: getSize(isSharing, 'reactionContainerSize'),
        height: getSize(isSharing, 'reactionContainerSize'),
        borderRadius: getSize(isSharing, 'reactionContainerSize') / 2,
        backgroundColor: props.colors.cornflowerBlue,
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: getSize(isSharing, 'offset'),
      },
      reaction: {
        fontSize: getSize(isSharing, 'reactionFontSize'),
      },
      topContainer: {
        flexDirection: 'row',
        position: 'absolute',
        top: getSize(isSharing, 'offset'),
        left: getSize(isSharing, 'offset'),
        right: getSize(isSharing, 'offset'),
        width: withWithOffset(width, isSharing),
      },
      microOffAndReactionContainer: {
        flex: isReactionOnn || isMicroOnn ? 1 : 0,
        flexDirection: 'row',
      },
      microOffImage: {
        width: getSize(isSharing, 'reactionContainerSize'),
        height: getSize(isSharing, 'reactionContainerSize'),
        marginLeft: getSize(isSharing, 'offset'),
        marginRight:
          isReactionOnn && isMicroOnn ? 0 : getSize(isSharing, 'offset'),
      },
      userContainer: {
        width: getSize(isSharing, 'userContainerSize'),
        height: getSize(isSharing, 'userContainerSize'),
        borderRadius: getSize(isSharing, 'userContainerSize') / 2,
        backgroundColor: props.colors.purple(0.2),
        justifyContent: 'center',
        alignItems: 'center',
      },
      userText: {
        fontSize: isSharing ? 13 : 30,
        color: props.colors.cornflowerBlue,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          borderRadius: 12,
        },
        topContainer: {
          top: isSharing ? 4 : 8,
          left: isSharing ? 4 : 8,
          right: isSharing ? 4 : 8,
        },
      },
    },
  )();
};
